import _ from 'lodash';

/**
 * Helper functions for creating record classes
 *
 *  schemas should be defined as:
 *
 *  {
 *      field: [ resolver, defaultValue ]
 *  }
 *
 *  eg:
 *
 *  {
 *      name: [ fields.string, 'pete'],
 *      age: [ field.number ]
 *  }
 */


function objFromSchema(schema, index, defaultVal = null) {
    return _.zipObject(_.keys(schema), _.map(schema, (def) => _.get(def, index, defaultVal)));
}

/**
 * Get the default values for a record schema
 */
export function getDefaults(schema) {
    return objFromSchema(schema, 1);
}

/**
 * Get the resolvers for a schema to use with LinkMappers construct helper
 */
export function getResolvers(schema) {
    return objFromSchema(schema, 0);
}



// WEBPACK FOOTER //
// ./src/helpers/Records.js